import omit from 'lodash/omit';

import { MerchantInfo } from './types';

const KEYS = {
  URL_DECORATOR: 'https://',
};

export const decorateUpdateRequest = (requestBody: Partial<MerchantInfo>) => {
  const { uuid, ...body } = requestBody;
  const result = omit(body, 'webhookUrl');

  if (body.processingFee !== undefined && body.processingFee !== null) {
    result.processingFee = Number(body.processingFee);
  }

  return result;
};

export const undecorateMerchantData = (merchant: MerchantInfo): MerchantInfo => ({
  ...merchant,
  webhookUrl: (merchant.webhookUrl || '').replace(KEYS.URL_DECORATOR, ''),
});
